import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '../../forms/button/button.module';
import { InformationSectionsComponent } from './information-sections.component';

@NgModule({
  declarations: [InformationSectionsComponent],
  imports: [CommonModule, ButtonModule],
  exports: [InformationSectionsComponent]
})
export class InformationSectionsModule {}
